import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaFutbol, FaBolt, FaMoneyBillWave, FaBook } from 'react-icons/fa';

const BottomNav = () => {
  return (
    <motion.nav 
      className="bottom-nav pb-safe"
      style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="grid grid-cols-4 h-16">
        {/* Прогнозы */}
        <NavLink 
          to="/" 
          end
          className={({ isActive }) => `
            bottom-nav-item
            ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}
          `}
        >
          {({ isActive }) => (
            <motion.div
              whileTap={{ scale: 0.9 }}
              className="flex flex-col items-center"
            >
              <FaFutbol className="bottom-nav-icon" />
              <span>Predictions</span>
              
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="w-1.5 h-1.5 bg-primary rounded-full absolute -top-1"
                />
              )}
            </motion.div>
          )}
        </NavLink>
        
        {/* Экспрессы */}
        <NavLink 
          to="/accumulators/"
          className={({ isActive }) => `
            bottom-nav-item
            ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}
          `}
        >
          {({ isActive }) => (
            <motion.div
              whileTap={{ scale: 0.9 }}
              className="flex flex-col items-center"
            >
              <FaBolt className="bottom-nav-icon" />
              <span>Accumulators</span>
              
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="w-1.5 h-1.5 bg-primary rounded-full absolute -top-1"
                />
              )}
            </motion.div>
          )}
        </NavLink>
        
        {/* Бонусы букмекеров */}
        <NavLink 
          to="/bookie-bonuses/"
          className={({ isActive }) => `
            bottom-nav-item
            ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}
          `}
        >
          {({ isActive }) => (
            <motion.div
              whileTap={{ scale: 0.9 }}
              className="flex flex-col items-center"
            >
              <FaMoneyBillWave className="bottom-nav-icon" />
              <span>Bonuses</span>
              
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="w-1.5 h-1.5 bg-primary rounded-full absolute -top-1"
                />
              )}
            </motion.div>
          )}
        </NavLink>
        
        {/* Руководства */}
        <NavLink 
          to="/betting-guides/"
          className={({ isActive }) => `
            bottom-nav-item
            ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}
          `}
        >
          {({ isActive }) => (
            <motion.div
              whileTap={{ scale: 0.9 }}
              className="flex flex-col items-center"
            >
              <FaBook className="bottom-nav-icon" />
              <span>Guides</span>
              
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="w-1.5 h-1.5 bg-primary rounded-full absolute -top-1"
                />
              )}
            </motion.div>
          )}
        </NavLink>
      </div>
    </motion.nav>
  );
};

export default BottomNav; 